var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.811,
    height: 68.542,
    viewBox: "0 0 82.811 68.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10158",
    "data-name": "Grupo 10158",
    transform: "translate(-3817.873 -3347.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7176",
    "data-name": "Trazado 7176",
    d: "M174.942,68.925H94.471a.671.671,0,0,0-.67.67v61.423a.671.671,0,0,0,.67.67h51.386v-1.341H95.142V81.639h79.129v48.709h-4.678v1.341h5.349a.671.671,0,0,0,.67-.67V69.594a.671.671,0,0,0-.67-.67ZM95.142,80.3V70.266h79.129V80.3Z",
    transform: "translate(3724.573 3278.581)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7177",
    "data-name": "Trazado 7177",
    d: "M557.144,93.226l-.947-.949-1.715,1.715-1.714-1.715-.95.949,1.715,1.715-1.715,1.714.95.948,1.714-1.715L556.2,97.6l.947-.948-1.715-1.714Z",
    transform: "translate(3339.684 3258.956)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7178",
    "data-name": "Trazado 7178",
    d: "M122.47,104.55H168.4v1.341H122.47Z",
    transform: "translate(3700.481 3248.643)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7179",
    "data-name": "Trazado 7179",
    d: "M165.161,261.29a4.564,4.564,0,0,0,0,9.127h16.667a4.564,4.564,0,0,0,0-9.127Zm19.889,4.563a3.226,3.226,0,0,1-3.223,3.223H165.161a3.223,3.223,0,1,1,0-6.445h16.667a3.227,3.227,0,0,1,3.222,3.223Z",
    transform: "translate(3668.44 3116.928)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7180",
    "data-name": "Trazado 7180",
    d: "M403.629,265.841a4.569,4.569,0,0,0-4.564-4.564H382.4a4.564,4.564,0,1,0,0,9.127h16.667a4.568,4.568,0,0,0,4.562-4.564Zm-24.451,0a3.226,3.226,0,0,1,3.223-3.223h16.667a3.223,3.223,0,1,1,0,6.445H382.4a3.225,3.225,0,0,1-3.221-3.222Z",
    transform: "translate(3485.887 3116.938)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7181",
    "data-name": "Trazado 7181",
    d: "M455.016,342.091a.67.67,0,0,0-1.17.428l-.6,20.317a.677.677,0,0,0,.428.646.7.7,0,0,0,.243.046.662.662,0,0,0,.508-.235l4.868-5.681,2.941,8.077,1.26-.46-2.941-8.077,7.382,1.221a.669.669,0,0,0,.607-1.108Zm4.619,13.551a.663.663,0,0,0-.617.225l-4.378,5.11.5-16.736,11.14,12.5Z",
    transform: "translate(3422.522 3049.216)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.f0dee29b369b8f0accb90d37c217e56f.svg";
export { ForwardRef as ReactComponent };